<template>
	<div class="position-relative">
	



		<div id="g_id_signin" class="auth-dialog__real-google-button-container" />
	
		
		
		<button class="button-auth--google d-flex align-center justify-center rounded-pill">
			<google class="button-auth__icon"></google>
			<p class="button-auth__text">{{buttonText}}</p>
		</button>




	</div>
</template>



<script>

import { ref, onMounted, onUnmounted, computed } from 'vue';
import Google from "@/icons/Google.vue";
import { AppConfigs } from "@/app.configs";
import { useAuthStore } from "@/store/AuthStore";

export default {
  name: "GoogleSignIn",
  components: {
    Google,
  },
  props: {
    action: {
      type: String,
      required: true,
      default: 'signin',
      validator: value => ['signin', 'signup'].includes(value)
    }
  },
  setup(props) {
    const authStore = useAuthStore();
    const isLoading = ref(false);

    const handleCredentialResponse = (response) => {
      isLoading.value = true;
      authStore.googleLoginResponse = response;
    };

    const initGis = () => {
      if (window.google && window.google.accounts) {
        window.google.accounts.id.initialize({
          client_id: AppConfigs.googleAppId,
          callback: handleCredentialResponse,
        });

        window.google.accounts.id.renderButton(document.getElementById("g_id_signin"), {
          theme: "outline",
          size: "large",
          shape: "pill",
          width: "400"
        });
      } else {
        console.error("Google API not loaded");
      }
    };

    onMounted(() => {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      script.onload = initGis;
      document.head.appendChild(script);
    });

    onUnmounted(() => {
      const script = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');
      if (script) {
        document.head.removeChild(script);
      }
    });


    const buttonText = computed(() => {
      return props.action === 'signin' ? 'Sign in with Google' : 'Sign up with Google';
    });


    return {
      initGis,
      isLoading,
      buttonText,
    };
  },
};
</script>